// Styles object for OnThisDay page

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    padding: '0',
    fontFamily: "'Inter', 'Segoe UI', 'Roboto', sans-serif",
    position: 'relative',
    overflowX: 'hidden',
    width: '100%',
    maxWidth: '100vw'
  },
  header: {
    backgroundColor: '#ffffff',
    padding: '20px',
    borderBottom: '2px solid #e9ecef',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  backButton: {
    backgroundColor: '#ffffff',
    border: '2px solid #007bff',
    color: '#007bff',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    marginBottom: '15px'
  },
  floatingButton: {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    backgroundColor: '#007bff',
    color: '#ffffff',
    border: 'none',
    padding: '15px 25px',
    borderRadius: '50px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '700',
    boxShadow: '0 4px 20px rgba(0,123,255,0.4)',
    zIndex: 1000,
    transition: 'all 0.3s ease',
    animation: 'slideInUp 0.4s ease'
  },
  headerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    textAlign: 'center'
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    margin: '0 0 8px 0',
    color: '#212529'
  },
  subtitle: {
    fontSize: '16px',
    color: '#6c757d',
    margin: 0
  },
  dateCard: {
    maxWidth: '1200px',
    margin: '20px auto',
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '15px',
    boxSizing: 'border-box'
  },
  dateDisplay: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  dateIcon: {
    fontSize: '28px'
  },
  dateTitle: {
    fontSize: '24px',
    fontWeight: '600',
    margin: 0,
    color: '#212529'
  },
  datePicker: {
    backgroundColor: '#f8f9fa',
    border: '2px solid #dee2e6',
    color: '#495057',
    padding: '10px 16px',
    borderRadius: '8px',
    fontSize: '15px',
    cursor: 'pointer',
    outline: 'none',
    fontWeight: '500',
    transition: 'all 0.2s ease'
  },
  tabContainer: {
    maxWidth: '1200px',
    margin: '20px auto',
    padding: '0 20px',
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    boxSizing: 'border-box'
  },
  tab: {
    backgroundColor: '#ffffff',
    border: '2px solid #dee2e6',
    color: '#6c757d',
    padding: '12px 24px',
    borderRadius: '10px',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    flex: '1 1 auto',
    minWidth: '120px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  activeTab: {
    backgroundColor: '#28a745',
    borderColor: '#28a745',
    color: '#ffffff',
    boxShadow: '0 4px 12px rgba(40,167,69,0.3)'
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto 40px',
    padding: '0 20px',
    minHeight: '400px',
    boxSizing: 'border-box',
    width: '100%'
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '80px 20px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  spinner: {
    width: '50px',
    height: '50px',
    border: '4px solid #e9ecef',
    borderTop: '4px solid #007bff',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginBottom: '20px'
  },
  loadingText: {
    color: '#6c757d',
    fontSize: '16px',
    marginBottom: '8px'
  },
  eventsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  eventCard: {
    display: 'flex',
    gap: '16px',
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #e9ecef',
    boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    alignItems: 'flex-start'
  },
  eventLeft: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    minWidth: '70px'
  },
  sportBadge: {
    fontSize: '32px',
    padding: '8px',
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    border: '2px solid #e9ecef'
  },
  yearBadge: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#007bff',
    backgroundColor: '#e7f3ff',
    padding: '6px 12px',
    borderRadius: '8px',
    whiteSpace: 'nowrap'
  },
  eventCenter: {
    flex: 1,
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start'
  },
  eventIcon: {
    fontSize: '24px',
    flexShrink: 0
  },
  eventContent: {
    flex: 1
  },
  eventText: {
    fontSize: '16px',
    lineHeight: '1.6',
    color: '#212529',
    margin: '0 0 12px 0',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    wordBreak: 'break-word'
  },
  relatedLinks: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  },
  link: {
    color: '#007bff',
    textDecoration: 'none',
    fontSize: '13px',
    padding: '6px 12px',
    backgroundColor: '#e7f3ff',
    borderRadius: '6px',
    border: '1px solid #b3d7ff',
    fontWeight: '500',
    transition: 'all 0.2s ease'
  },
  noData: {
    textAlign: 'center',
    padding: '60px 20px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  noDataIcon: {
    fontSize: '64px',
    display: 'block',
    marginBottom: '16px'
  },
  noDataText: {
    fontSize: '18px',
    color: '#6c757d',
    marginBottom: '20px'
  },
  resetButton: {
    backgroundColor: '#007bff',
    border: 'none',
    color: '#ffffff',
    padding: '12px 24px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: '600',
    transition: 'all 0.3s ease'
  }
};


export default styles;
